module.exports = __webpack_public_path__ + "img/ch31.00dccb7d.jpg";